import React from "react";
import "../css/Projects.css";
import ProjectsTips from "./ProjectsTips";
import image1 from "../img/Capture.JPG";
import image2 from "../img/WhatssApp.JPG";
import image3 from "../img/Sport shop.JPG";
import image4 from "../img/Youtube.JPG";
import image5 from "../img/GymPhoto.JPG";
import image6 from "../img/Instagram.JPG";
import image7 from "../img/image7.JPG";
import image9 from "../img/image9.JPG";
import image10 from "../img/carShop.JPG";

function Projects() {
  return (
    <div className='projects' id='portfolio'>
      <div className='projectsTitle'>
        <h1 className='animate__animated animate__bounce animate__infinite'>
          Some of My Work
        </h1>
        <hr />
      </div>
      <div className='projects__container'>
        <div className='row'>
          <ProjectsTips
            image={image1}
            title='Amazon Clone'
            demoLink='https://clone-ca502.web.app/'
            codeLink='https://github.com/ilirshala/Amazon-Clone'
            paragraph='Amazon Clone is my first project with React Js. The web app allows people to add an item to cart, remove it, count all products price. It look like real Amazon web page.'
            made1='React Js'
            made2='Material UI'
            made3='CSS3'
            made4='Firebase'
          />
          <hr />
          <ProjectsTips
            image={image2}
            title='WhatsApp Clone'
            demoLink='https://whats-app-clone-6c0e2.web.app/'
            codeLink='https://github.com/ilirshala/WhatsApp-Clone'
            paragraph='WhatsApp Clone is my second project with React Js. The web app allows people to send messages, loggin with google authentication, talk with each other etc.'
            made1='React Js'
            made2='Material UI'
            made3='CSS3'
            made4='Firebase'
          />
          <hr />
          <ProjectsTips
            image={image3}
            title='Sport shop'
            demoLink='https://sportshop-7.web.app/'
            codeLink='https://github.com/ilirshala/Sportshop-WebApp'
            paragraph='Sport shop page if one of my projects that I made for college. You can add a product in basket remove it check price of all products etc. To make this project I have used React Js, Material UI, CSS and to deploy it Firebase.'
            made1='React Js'
            made2='Material UI'
            made3='CSS3'
            made4='Redux'
          />
          <hr />
          <ProjectsTips
            image={image4}
            title='Youtube Clone'
            demoLink='https://clone-34ca8.web.app/'
            codeLink='https://github.com/ilirshala/Youtube-Clone'
            paragraph='Youtube Clone is made with React Js. The web app allows people to search oe of videos route through pages etc.'
            made1='React Js'
            made2='Material UI'
            made3='React Router'
            made4='CSS3'
          />
          <hr />
          <ProjectsTips
            image={image5}
            title='Gym Page'
            demoLink='https://gym2020-d5257.web.app/'
            codeLink='https://github.com/ilirshala/Gym-Website'
            paragraph='Gym page is one of my big projects I made it for college. You can route through links and see, gallery page, contact page etc.'
            made1='React Js'
            made2='Material UI'
            made3='React Router'
            made4='CSS3'
          />
          <hr />
          <ProjectsTips
            image={image6}
            title='Instagram Clone'
            demoLink='https://instgaram-clone-c6137.web.app/'
            codeLink='https://github.com/ilirshala/Instagram-Clone'
            paragraph='Instagram clone is one of my React projects. Hope you will like it'
            made1='React Js'
            made2='Material UI'
            made3='React Router'
            made4='CSS3'
          />
          <hr />
          <ProjectsTips
            image={image7}
            title='Hamburger Restaurant'
            demoLink='https://restauranthamburgers.netlify.app/'
            codeLink='https://github.com/ilirshala/Hamburger-Restaurant'
            paragraph='Hamburger Restaurant page is one of my best projects. By building this project has helped me to improve my skills!'
            made1='React Js'
            made2='Material UI'
            made3='Redux'
            made4='CSS3'
          />
          <hr />
          <ProjectsTips
            image={image10}
            title='Car Shopping Center'
            demoLink='https://car-shop-project.netlify.app/'
            codeLink='https://github.com/ilirshala/car-shop'
            paragraph='Car Shop is project that I made using React components, hooks, redux etc. There are to many real project functions those are used on e-commerce sites too. Hope you enjoy it!'
            made1='React Js'
            made2='Material UI'
            made3='Redux'
            made4='Sass'
          />
          <hr />
        </div>
      </div>
    </div>
  );
}

export default Projects;
